module.exports = __webpack_public_path__ + "img/sunflower.be5030ca.webp";